import { BaseAdaptiveCardRenderer } from '@ninjacart/nc-nk-adaptive-cards';
import { IAdaptiveActionCard } from '@ninjacart/nc-nk-core';
import { useAppPersistenceModerationStore } from '@ninjacart/nc-nk-moderation';
import {
  useAppPersistenceEdTechStore,
  useAppPersistenceStore,
  useEventZStore,
  useProfileStore,
} from '@ninjacart/nc-nk-store';
import { memo } from 'react';

interface ListItemRendererProps {
  item: IAdaptiveActionCard;
  index: number;
  onCommentBottomSheetOpen: (item: IAdaptiveActionCard, index: number) => void;
  updateConnectionStatus?: Function;
  locationPermissionAsk?: () => void;
  weatherLocationPermissionAsk?: () => void;
  isWeatherWidgetAvailable?: boolean;
  onReportBottomSheetOpen: Function;
  cropPreference?: any[];
  animalPreference?: any[];
  setVideoFeedIndex?: (index: number) => void;
}

export const ListItemRenderer = memo(
  ({
    item,
    index,
    onCommentBottomSheetOpen,
    updateConnectionStatus,
    locationPermissionAsk,
    isWeatherWidgetAvailable,
    onReportBottomSheetOpen,
    cropPreference,
    animalPreference,
    setVideoFeedIndex,
  }: ListItemRendererProps) => {
    // console.log('SSR: Trying to list item renderer!!!', index);
    const userProfile = useProfileStore((state) => state.userProfile);
    const bannerAdKeywords = useEventZStore((state) => state.bannerAdKeywords);
    const hasUserLoggedIn = userProfile?.access_token?.trim()?.length ? true : false;
    const setModerationAppLanguageLabel = useAppPersistenceModerationStore(
      (state) => state.setModerationAppLanguageLabel
    );
    const setEdTechAppLanguageLabel = useAppPersistenceEdTechStore(
      (state) => state.setEdTechAppLanguageLabel
    );

    const adSizeDefsPreloaded = useAppPersistenceStore((state) => state.ads.adUnitsWithSizes);
    // Determine if this item type should be rendered
    const shouldRender = () => {
      switch (item.type) {
        case 'CROP':
          return hasUserLoggedIn && cropPreference?.length === 0;
        case 'ANIMAL':
          return hasUserLoggedIn && animalPreference?.length === 0;
        default:
          return true;
      }
    };

    if (!shouldRender()) return null;

    // Common props for the adaptive card renderer
    const cardProps = {
      item,
      index,
      userProfile,
      onReportBottomSheetOpen,
      onCommentBottomSheetOpen,
      updateConnectionStatus,
      cropPreference,
      animalPreference,
      setEdTechAppLanguageLabel,
      setModerationAppLanguageLabel,
      languages: item?.actionData?.content,
      carouselData: item?.actionData,
      locationPermissionAsk,
      isWeatherWidgetAvailable,
      itemKey: `list-item-${index}`,
      shortVideos: item,
      setVideoFeedIndex,
      adSizeDefsPreloaded,
      bannerAdKeywords,
      unitId: item?.actionData?.content?.unitId,
      adSizeDefs: item?.actionData?.content?.adSizeDefs ?? [],
      adsPreloadData: adSizeDefsPreloaded,
      // Add other props based on specific needs
    };

    return <BaseAdaptiveCardRenderer name={item.type!} {...cardProps} />;
    // return <></>
  },
  // Custom comparison function to optimize re-renders
  (prevProps, nextProps) => {
    return (
      prevProps.index === nextProps.index &&
      prevProps.item.type === nextProps.item.type &&
      prevProps.isWeatherWidgetAvailable === nextProps.isWeatherWidgetAvailable
    );
  }
);
